import React, { useState } from "react";
import styles from "../QuestionBox/QuestionBoxStyles.module.css";
import moment from "moment";
import { convertEpochToTimestamp } from "../../utils";
import "./AnswerCardStyles.css";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import CarouselImage from "../Carousel/Carousel";
import AttachmentBox from "../AttachmentBox/AttachmentBox";
import Voting from '../Rating/voting';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { InView } from "react-intersection-observer";
import { updateViewCount } from "../../API/api";
import { BASE_URL, CURRENT_ROLE } from "../../API/url";
import { useLocation } from "react-router-dom";
import Rating from "../Rating/Rating";
import styles2 from "./NewCardStyles.module.css";

export default function ThreadAnswerCard({ answer, question }) {
  const dispatch = useDispatch();
  const currentPath = useLocation();
  if(currentPath.pathname.includes('editor') && answer.expert === null){
    answer.expert = {};
    answer.expert.firstName = 'Vizerto';
    answer.expert.lastName = 'Bot';
    answer.expert.userUuidStr = '';
  }
  const { advanceFilterModalToggle, getSelectedAnswer, getSelectedQuestion, allScrolledAnswerUuid, answerUuidSentToUpdateViewCount } =
    bindActionCreators(Actions, dispatch);
    const trendingState = useSelector((state) => state.trending);

  const searchState = useSelector((state) => state.search);
  const domainState = useSelector((state) => state.domain.ratings);
  const userState = useSelector((state) => state.user);
  const [isShowReply, setIsShowReply] = useState(false);
  const modalName = useSelector((state) => state.domain.modalName);
  const isRatingDone = useSelector((state) => state.domain.isRatingLoad);

  const extractProfilePicFromStore = () => {
    let imgData = searchState.usersProfilePicData.find(
      (obj) => obj.uuid === answer.expertImage.uuid
    );
    if (imgData !== undefined) {
      let userPic = `data:image/JPEG;base64,${imgData.img}`;
      return userPic;
    } else {
      return "";
    }
  };

  const onClickRFU = () => {
    advanceFilterModalToggle({ bool: true, value: "requestForUpdate" });
    getSelectedAnswer(answer);
    getSelectedQuestion(question);
  };

  const onChangeReplyBox = () => {
    setIsShowReply(!isShowReply);
  };
  const momentit = (stime) => {
    if (Number(Date.now()) - Number(stime) < 259200000) {
      return moment(new Date(Number(stime))).fromNow();
    } else {
      return moment(convertEpochToTimestamp(stime)).format("ll");
    }
  };

  const helpfulAPIPayload = {
    questionUuid: question.questionUuid,
    answerUuid: answer.answerUuid,
    status: "accepted",
    questionText: searchState.inputValue,
    answerText: answer.threads.join(","),
    pdfId: "",
  };
  const getAnswerUuidsForViewCountUpdation =(flag, question)=>{
    if(flag){
      if(!trendingState.AllScrolledAnswerUuid.includes(question.docId)){
        let payload ={
          answerIds:[],
          docIds:question.docId.split()
        }
        let ar = trendingState.AllScrolledAnswerUuid;
        ar.push(question.docId)
        allScrolledAnswerUuid(ar);
        updateViewCount(payload, answerUuidSentToUpdateViewCount)
    }
  }}

  const state = useSelector((state) => state?.user);
  const location = useLocation();
 
  // const isId4Present = data.some(item => item.id === 4);
  const check = state?.roles
    ?.filter((item) => item.roleName === "Seeker")
    .map((item) => {
      let val = item?.permissions;
      return val.some(item => item.id === 9);
    });

  const isDisabled = check[0]===true ? false : true ;


  return (
    <InView as="div" onChange={(inView, entry) => getAnswerUuidsForViewCountUpdation(inView,question)}>
      <div className="col-md-12">
      <div className={styles.answerDiv}>
        <div className={styles.expertInfo}>
          <div className={styles2.newContainer}>
            <div className={styles2.subcontainerLeft}>
            <div style={{display:'flex', justifyContent:'start', flexWrap:'wrap', alignItems:'center'}}>
              <div>
              <img
            className="rounded-circle"
            alt="40x40"
            src={
              extractProfilePicFromStore() ||
              require("../../Images/bot-icon.png")
            }
            id={styles.expertProfilePicture}
            data-holder-rendered="true"
          ></img>
              </div>
              <div style={{marginLeft:'5px', fontSize:'14px', fontWeight:'500'}}><p style={{marginBottom:'0px'}}>{answer.expert.firstName}</p><p style={{marginBottom:'0px'}}>{answer.expert.lastName !== 'Bot' && answer.expert.lastName}</p></div>
              </div>
              <div style={{display:'flex', justifyContent:'start', flexWrap:'wrap', alignItems:'center'}}>
              {answer.answeredTimestamp && (
              <div className={styles.answeredInfo}>
                <span className="datestamp">
                  Answered {momentit(answer.answeredTimestamp)}
                </span>
              </div>
            )}
              </div>
              <div style={{display:'flex', justifyContent:'start'}}>
            {question.usageAccess === "internal" && (
                <div
                className={styles.viewScore}
                >
                  <i className="fa fa-user-times"></i>&nbsp;Internal Only
                </div>
              )}
            </div>
            </div>
            <div className={styles2.subcontainerMiddle} style={{backgroundColor:`${currentPath.pathname.includes('/search')?question.confidence?'green':'orange':'var(--light_color_shade)'}`}}></div>
            <div className={styles2.subcontainerRight}>
         {question.threadType === 'THREAD' && <div>
         <div
            className="row mt-2 me-2 mb-2"
            style={{ display: "flex", justifyContent: "end" }}
          >
            <div className="firstThreadLayout" style={{ width: "95%" }}>
              <div
                className="innerThreadDiv"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <h4 className="firstReply" style={{ width: "80%" }}>
                  {answer.threads && answer.threads[0]}
                </h4>
                {!isShowReply ? (
                  <span
                    style={{
                      width: "20%",
                      textAlign: "end",
                      color: "#4F6384",
                      cursor: "pointer",
                      fontSize: "12px",
                    }}
                    onClick={() => onChangeReplyBox()}
                  >
                    Show {answer.threads.length - 1} Replies{" "}
                    <i
                      className="fa fa-arrow-down"
                      onClick={() => onChangeReplyBox()}
                      style={{ cursor: "pointer" }}
                    ></i>
                  </span>
                ) : (
                  <span
                    style={{
                      width: "20%",
                      textAlign: "end",
                      color: "#4F6384",
                      cursor: "pointer",
                      fontSize: "12px",
                    }}
                    onClick={() => onChangeReplyBox()}
                  >
                    Hide Replies{" "}
                    <i
                      className="fa fa-arrow-up"
                      onClick={() => onChangeReplyBox()}
                      style={{ cursor: "pointer" }}
                    ></i>
                  </span>
                )}
              </div>
              {answer.threadAttachmentsURL[0].length > 0 && (
                <div style={{ textAlign: "center" }}>
                  <CarouselImage attachments={answer.threadAttachmentsURL[0]} />
                </div>
              )}
              <div style={{ display: "flex" }}>
                {answer.threadAttachments &&
                  answer.threadAttachments[0].map((attachment) => {
                    return (
                      <div className="mt-3 mb-3 ms-3">
                        <AttachmentBox attachment={attachment} />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          {isShowReply &&
            answer.threads &&
            answer.threads.map((thread, index) => {
              if (index !== 0) {
                return (
                  <div
                    className="row me-2 mb-2"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <div className="firstThreadLayout" style={{ width: "90%" }}>
                      <div className="innerThreadDiv">
                        <h4 className="firstReply">{thread}</h4>
                      </div>
                      {answer.threadAttachmentsURL[index].length > 0 && (
                        <div style={{ textAlign: "center" }}>
                          <CarouselImage
                            attachments={answer.threadAttachmentsURL[index]}
                          />
                        </div>
                      )}
                      <div style={{ display: "flex" }}>
                        {answer.threadAttachments &&
                          answer.threadAttachments[index].map(
                            (attachment) => {
                              return (
                                <div className="mt-3 mb-3 ms-3">
                                  <AttachmentBox attachment={attachment} />
                                </div>
                              );
                            }
                          )}
                      </div>
                    </div>
                  </div>
                );
              }
            })}
         </div>}
         {question.threadType === 'REUSABLE_THREAD_QA' && <div>
         <div
            className="row mt-2 me-2 mb-2"
            style={{ display: "flex", justifyContent: "end" }}
          >
            <div className="firstThreadLayout" style={{ width: "95%" }}>
              <div
                className="innerThreadDiv"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <h4 className="firstReply" style={{ width: "80%" }}>
                  {answer.threads && answer.threads[0]}
                </h4>
              </div>
            </div>
            <div className="firstThreadLayout mt-2" style={{ width: "90%" }}>
              <div
                className="innerThreadDiv"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <h4 className="firstReply" style={{ width: "80%" }}>
                  {answer.threads && answer.threads[1]}
                </h4>
                {!isShowReply ? (
                  <span
                    style={{
                      width: "20%",
                      textAlign: "end",
                      color: "#4F6384",
                      cursor: "pointer",
                      fontSize: "12px",
                    }}
                    onClick={() => onChangeReplyBox()}
                  >
                    Show Full Threads{" "}
                    <i
                      className="fa fa-arrow-down"
                      onClick={() => onChangeReplyBox()}
                      style={{ cursor: "pointer" }}
                    ></i>
                  </span>
                ) : (
                  <span
                    style={{
                      width: "20%",
                      textAlign: "end",
                      color: "#4F6384",
                      cursor: "pointer",
                      fontSize: "12px",
                    }}
                    onClick={() => onChangeReplyBox()}
                  >
                    Hide full Threads{" "}
                    <i
                      className="fa fa-arrow-up"
                      onClick={() => onChangeReplyBox()}
                      style={{ cursor: "pointer" }}
                    ></i>
                  </span>
                )}
              </div>
            </div>
          </div>
          {isShowReply &&<>
          <div>
          <hr style={{marginBottom:'2px',marginLeft:'10%'}} />
          </div>
          <div style={{textAlign:'center', fontSize:'14px', marginBottom:'4px'}}>
          Original Thread</div>
          </>}
          {isShowReply &&
            answer.threads &&
            answer.threads.map((thread, index) => {
              if (index !== 0 && index !== 1) {
                return (
                  <div
                    className="row me-2 mb-2"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <div className="firstThreadLayout" style={{ width: "90%" }}>
                      <div className="innerThreadDiv">
                        <h4 className="firstReply">{thread}</h4>
                      </div>
                      {answer.threadAttachmentsURL[index].length > 0 && (
                        <div style={{ textAlign: "center" }}>
                          <CarouselImage
                            attachments={answer.threadAttachmentsURL[index]}
                          />
                        </div>
                      )}
                      <div style={{ display: "flex" }}>
                        {answer.threadAttachments &&
                          answer.threadAttachments[index].map(
                            (attachment) => {
                              return (
                                <div className="mt-3 mb-3 ms-3">
                                  <AttachmentBox attachment={attachment} />
                                </div>
                              );
                            }
                          )}
                      </div>
                    </div>
                  </div>
                );
              }
            })}
         </div>}
         </div>
          </div>
         {/* dont change from here */}
          {modalName !== "generativeREsponse" && <div style={{display:'flex',justifyContent:'space-between'}}>
            {answer.popularityScore && (
              <div style={{display:'flex',alignItems:"center"}}>
              <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip>Number of times this answer was viewed</Tooltip>
                  }
                >
                  <span style={{ cursor: "pointer" }}>
                    <span className={styles.viewCount}>
                      {answer.popularityScore && <i className="fa fa-eye"></i>}
                    </span>
                    <span className={styles.viewScore}>
                      {answer.popularityScore}
                    </span>
                  </span>
                </OverlayTrigger>
              </div>
            )}
            <div>
              <div className="text-end">
                <div className={styles.helpfulButton}>
                  { answer.isVerifyShow === undefined ? (
                    CURRENT_ROLE === 'Seeker' && <span style={{ fontSize: "12px", marginTop: "8px" }}>
                      <button
                        onClick={() => onClickRFU()}
                        disabled={isDisabled}
                        className={isDisabled ? styles2.disabledButton:`btn btn-primary videoshowbuttonAB`}
                        style={{minWidth:'80px', marginBottom:`${isDisabled? "10px":"0px"}`}}
                        >
                        Verify
                      </button>
                    </span>
                  ) : (
                    <span style={{ fontSize: "12px", marginTop: "15px" }}>
                      Expert will verify it shortly.{" "}
                      <img
                        src={require("../../Images/chatoutline.png")}
                        style={{
                          width: "18px",
                          height: "20px",
                          marginTop: "-3px",
                        }}
                      />
                    </span>
                  )}
                  &nbsp;&nbsp;
                  {isRatingDone && !currentPath.pathname.includes('editor') && domainState !== null && domainState[answer.docId] !== undefined && (
                    <div id={styles.btnHelpful}>
                      <Voting
                        helpful={helpfulAPIPayload}
                        answer={answer}
                      />
                    </div>
                  )}
                  {isRatingDone && currentPath.pathname.includes('editor') &&  domainState !== null &&
                    domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId] !== undefined && (
                      <div id={styles.btnHelpful}>
                        <Rating
                          helpful={helpfulAPIPayload}
                          id={answer.docId === undefined ?answer.origAnswerUuid:answer.docId}
                          rating={domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId]}
                          isDisable={
                            answer.expert.lastName === "Bot"
                              ? true
                              : undefined
                          }
                        />
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>}
        </div>
      </div>
    </div>
    </InView>
  );
}
